import React from 'react';
import { StyledTableCard, Header, HeaderLabel } from './shared';
import { TableSpinner } from '../TableSpinner';
var EmptyCard = function (_a) {
    var headerGroups = _a.headerGroups, isLoading = _a.isLoading;
    var render = headerGroups[0].headers[0].render;
    return (React.createElement(StyledTableCard, { tabIndex: -1 },
        React.createElement(Header, null,
            React.createElement(HeaderLabel, null, render('Header'))),
        isLoading ? React.createElement(TableSpinner, null) : null));
};
export default EmptyCard;
//# sourceMappingURL=EmptyCard.js.map